@if (!disabled) {
  <svg:g [attr.data-testid]="'junction-group'">
    <svg:circle
      class="sensing"
      [attr.cx]="dx"
      [attr.cy]="dy"
      r="20"
      [attr.data-testid]="'junction-sensing-circle'"
      ></svg:circle>
      <svg:circle
        [ngClass]="{ dark: dark }"
        [attr.cx]="dx"
        [attr.cy]="dy"
        [attr.stroke]="color"
        r="5"
        [attr.data-testid]="'junction-main-circle'"
        ></svg:circle>
        <svg:circle
          class="solid"
          [attr.cx]="dx"
          [attr.cy]="dy"
          [attr.fill]="color"
          r="0"
          [attr.data-testid]="'junction-solid-circle'"
          ></svg:circle>
          </svg:g>
        }
